/** API base URL — set via REACT_APP_API_URL (Docker / .env), fallback for non-Docker deploy */
export const url =
  process.env.REACT_APP_API_URL ||
  "https://mua.kpru.ac.th/FrontEnd_Diploma/";

/** React Router basename — must match package.json homepage path */
export const basename =
  process.env.REACT_APP_BASENAME || "/webregisfinish";

export const url_web =
  process.env.REACT_APP_PUBLIC_URL ||
  (typeof window !== "undefined"
    ? `${window.location.origin}${basename}/`
    : `https://e-student.kpru.ac.th${basename}/`);
